/**
 * Example JavaScript singleton module
 */

var Studio = (function($) {
  function initStudioEquipment() {
    $("#link-equipment").click(function(e) {
      e.preventDefault();
      $(".studio-equipment-list").toggleClass(
        "studio-equipment-list--expanded"
      );
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".page-template-template-studio-equipment").length) {
      return;
    }

    initStudioEquipment();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Studio.init);
